var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sk-fading-circle"},_vm._l((12),function(i){return _c('div',{key:i,staticClass:"sk-circle",class:['sk-circle', `sk-circle-${i}`]})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }